module.exports = __webpack_public_path__ + "static/media/golden_gate_grey.ead10dd8.svg";